import { fetchMonthBasedRegistrationData } from './fetchMonthBasedRegistrationData';
import { fetchOperatorDailyStats } from './fetchOperatorDailyStats';
import { fetchOperatorsStatistics } from './fetchOperatorsStatistics';
import { fetchOperationMetrics } from './fetchOperationMetrics';
import { fetchServiceMetricsData } from './fetchServiceMetricsData';
import { fetchTimeBasedRegistrationData } from './fetchTimeBasedRegistrationData';

export const statisticsService = {
  fetchMonthBasedRegistrationData,
  fetchOperatorDailyStats,
  fetchOperatorsStatistics,
  fetchOperationMetrics,
  fetchServiceMetricsData,
  fetchTimeBasedRegistrationData,
};
